// ===================== Показ слайдов =======================
let pos = 0; // Номер слайда для показа
const prev = document.querySelector('.slider__arrow-prev');
const next = document.querySelector('.slider__arrow-next');
const slides = document.querySelectorAll('.slide');
const topics = document.querySelectorAll('.slider__topic');
const slideNum = document.querySelectorAll('.slider__item')[1];

if (slides.length !== 0 && topics.length !== 0) {
	// Выделение текущего названия слайда
	topics[pos].classList.add('slider__topic_active-true');
	slides[pos].classList.add('slide_show-true');
	changeSlideNum();

	// Переход по нажатию на темы слайдов
	topics.forEach((item, index) => {
		item.addEventListener('click', function () {
			clearTopics();
			slides[pos].classList.remove('slide_show-true');
			pos = index;
			changeSlideNum();
			slides[pos].classList.add('slide_show-true');
			this.classList.add('slider__topic_active-true');
		});
	});

	// Листание назад с закольцовыванием
	prev.addEventListener('click', function () {
		clearTopics();
		slides[pos].classList.remove('slide_show-true');
		pos > 0 ? pos-- : (pos = topics.length - 1);
		changeSlideNum();
		slides[pos].classList.add('slide_show-true');
		topics[pos].classList.add('slider__topic_active-true');
	});

	// Листание вперёд с закольцовыванием
	next.addEventListener('click', function () {
		clearTopics();
		slides[pos].classList.remove('slide_show-true');
		pos < topics.length - 1 ? pos++ : (pos = 0);
		changeSlideNum();
		slides[pos].classList.add('slide_show-true');
		topics[pos].classList.add('slider__topic_active-true');
	});

	// Выбор темы слайда
	slides.forEach((item) => {
		const slideColumns = item.querySelectorAll('.slide__column');
		const slideTexts = item.querySelectorAll('.slide__column p:last-child');
		const slideCommonText = item.querySelector('.slide__text-common');

		// Отображение первой колонки по умолчанию
		if (slideTexts.length !== 0) {
			slideCommonText.innerHTML = slideTexts[0].innerHTML;
			slideColumns[0].classList.add('selected');
		}

		// Отображение колонки по клику на иконку/заголовок
		slideColumns.forEach((col, colNum) => {
			if (col.getElementsByTagName('img').length !== 0) {
				col.childNodes[0].childNodes[0].addEventListener('click', () => {
					slideCommonText.innerHTML = slideTexts[colNum].innerHTML;

					slideColumns.forEach((i) => {
						i.classList.remove('selected');
					});
					col.classList.add('selected');
				});
			} else if (col.getElementsByTagName('p').length !== 0) {
				col.children[0].addEventListener('click', () => {
					slideCommonText.innerHTML = slideTexts[colNum].innerHTML;

					slideColumns.forEach((i) => {
						i.classList.remove('selected');
					});
					col.classList.add('selected');
				});
			}
		});
	});
}

// --------------------------- Функции -----------------------
// Сброс выделения тем слайдов
function clearTopics() {
	topics.forEach((item) => {
		item.classList.remove('slider__topic_active-true');
	});
}

// Отображение номера текущего слайда
function changeSlideNum() {
	slideNum.innerHTML = +pos + 1 + ' / ' + topics.length;
}
